import { PriceContextValue } from '@/v2/components/ui/Price/types';
import { createCtx } from '@/v2/utils/createCtx';

export const [usePrice, PriceProvider] = createCtx<PriceContextValue>();
